module.exports = __webpack_public_path__ + "img/duplicate.c11f8edb.svg";